import { render, staticRenderFns } from "./ODoServerActionButton.vue?vue&type=template&id=3a4883eb&scoped=true"
import script from "./ODoServerActionButton.vue?vue&type=script&lang=js"
export * from "./ODoServerActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4883eb",
  null
  
)

export default component.exports